import React from 'react';

import { SOCIAL_PAGES_LINKS } from '../../../../../const';
import FacebookIcon from '../../../../icons/footerSocials/FacebookIcon';
import InstagramIcon from '../../../../icons/footerSocials/InstagramIcon';
import TwitterIcon from '../../../../icons/footerSocials/TwitterIcon';
import YoutubeIcon from '../../../../icons/footerSocials/YoutubeIcon';
import styles from './styles.module.scss';

const staticLinksConfig = [
    {
        Icon: FacebookIcon,
        link: SOCIAL_PAGES_LINKS.FACEBOOK
    },
    {
        Icon: InstagramIcon,
        link: SOCIAL_PAGES_LINKS.INSTAGRAM
    },
    {
        Icon: YoutubeIcon,
        link: SOCIAL_PAGES_LINKS.YOUTUBE
    },
    {
        Icon: TwitterIcon,
        link: SOCIAL_PAGES_LINKS.TWITTER
    }
];
export const SocialPagesList = () => {
    return (
        <ul className={styles.socials}>
            {staticLinksConfig.map((item) => {
                const Icon = item.Icon;
                return (
                    <li key={item.link}>
                        <a href={item.link} target="_blank" className={styles.social}>
                            <Icon />
                        </a>
                    </li>
                );
            })}
        </ul>
    );
};

export default SocialPagesList;
